import React, {useEffect,useState} from 'react';
import {getFilterProductLine} from "../../../microComponents/tablePages/getFilterProductLine";
import FilterSelectOption from "../../../microComponents/tablePages/filter/FilterSelectOption";

const FilterProductLine = () => {
    const [filterProductLine, setFilterProductLine] = useState([]);
    const [productLineLoading, setProductLineLoading] = useState(false);

    useEffect(() => {
        getFilterProductLine(setFilterProductLine, setProductLineLoading)

    }, []);
    return (
        <FilterSelectOption data={{
            filterName: 'productLine', loading: productLineLoading, placeholder: 'خط تولید', options: filterProductLine
        }}/>

    );
};

export default FilterProductLine;